import React from "react";
import PrivateEventPage from "./PrivateEventPage";

const HERO = "https://customer-assets.emergentagent.com/job_spirituel-wellness/artifacts/nk6rmmbw_soire%CC%81es%20prive%CC%81es%20-%20Grande.jpeg";

const FAQ_EXTRA = [
  {
    q: "Quels types de soirées privées peux-tu animer ?",
    a: "Anniversaires (surtout les dizaines : 30, 40, 50 ans), soirées Pleine Lune ou Nouvelle Lune entre amies, mariages (vin d'honneur ou after), baby showers, soirées de fin d'année, retraites bien-être en mode home… Toute occasion qui mérite un moment d'intimité spirituelle.",
  },
  {
    q: "Et pour une soirée Pleine Lune ou Nouvelle Lune ?",
    a: "C'est ma spécialité ! Je propose un Cercle de Lune complet : ouverture de l'espace, intentions (Nouvelle Lune 🌑) ou libérations (Pleine Lune 🌕), guidance collective et 1 carte personnalisée par participante. Combinable avec un Corner de Voyance pour des tirages individuels à la suite.",
  },
];

export default function SoireePriveePage() {
  return (
    <PrivateEventPage
      slug="soiree-privee"
      h1="Soirée Voyance Privée à Domicile — Anniversaire, Pleine Lune, mariage"
      heroEyebrow="Soirée privée à domicile"
      heroSubtitle="Fais rayonner ton anniversaire, ta soirée Pleine Lune ou ton événement entre amies avec une expérience spirituelle pensée pour ton groupe : voyance bienveillante, mini-tirages et rituels lunaires qui laissent une empreinte mémorable. 🌕🌑"
      metaTitle="Soirée Voyance Privée à Domicile — Anniversaire & Pleine Lune"
      metaDescription="Soirée voyance privée à domicile pour anniversaire, mariage, vin d'honneur ou cercle de Pleine Lune. Tirages individuels et rituels collectifs. À partir de 70€/h, jusqu'à 10 personnes. Déplacement dans un rayon de 50 km autour de Montélimar (Drôme, Ardèche, Vaucluse)."
      keywords="soirée voyance à domicile, voyante à domicile, soirée privée voyance, animation anniversaire voyance, cercle de Pleine Lune, soirée Nouvelle Lune, voyance entre amies, animation vin d'honneur voyance, soirée tarot privée, animation Drôme, voyance Montélimar, voyance Valence, voyance Ardèche"
      heroImage={HERO}
      serviceName="Soirée Voyance Privée à Domicile"
      serviceDescription="Animation voyance privée à domicile pour anniversaire, soirée Pleine/Nouvelle Lune, mariage, vin d'honneur ou événement entre amies. Tirages individuels (Corner de Voyance), Cercle de Lune collectif, formule Combo. Jusqu'à 10 participants, 2 à 3 heures, à partir de 70€/heure. Déplacement dans un rayon de 50 km autour de Montélimar (Drôme, Ardèche, Vaucluse)."
      faqExtra={FAQ_EXTRA}
      ctaSubject="Devis Soirée Voyance Privée — Bilan 2 Vie"
    />
  );
}
